export default __webpack_public_path__ + "guide--vector-tiles-standards-cw-960-38b0943e388e2d043bc278937adac383.webp";